import React from "react";
import MenuIcon from "@mui/icons-material/Menu";
import "../styles/Header.css";

export default function Header({ userName, onMenuOpen }) {
  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-left">
          <h1 className="app-title">
            <span className="title-icon">📚</span>
            <span className="title-text">Spelling Trainer</span>
          </h1>
        </div>
        {userName && (
          <div className="header-center">
            <span className="user-greeting">Hi, {userName}!</span>
          </div>
        )}
        <div className="header-right">
          <button className="btn-burger" onClick={onMenuOpen} aria-label="Open menu">
            <MenuIcon />
          </button>
        </div>
      </div>
    </header>
  );
}
